import React from 'react';

const PlanExecution = React.lazy(() => import('./views/plan-execution/PlanExecution'));
const PlanList = React.lazy(() => import('./views/plan-list/PlanList'));
const ToDo = React.lazy(() => import('./views/to-do/ToDo'));
const BidPlanProfit = React.lazy(() => import('./views/bid-plan-profit/BidPlanProfit'));
const ChangePassword = React.lazy(() => import('./views/pages/change-password/ChangePassword'));
const SiteNotSubjectToBidding = React.lazy(() =>
  import('./views/sites-not-subject-to-bidding/SiteNotSubjectToBidding')
);
const ImbalancePrices = React.lazy(() => import('./views/imbalance-prices/ImbalancePrices'));
const SiteInformation = React.lazy(() => import('./views/site-information/SiteInformation'));
const TransactionResults = React.lazy(() =>
  import('./views/transaction-results/TransactionResults')
);
const ErrorPage = React.lazy(() => import('./views/err/errorPage'));
const routes = [
  { path: '/to-do', exact: true, name: 'TODO', component: ToDo, service_id: 'todo' },
  { path: '/plan-list', exact: true, name: '計画一覧', component: PlanList },
  { path: '/plan-execution', exact: true, name: '計画立案実行', component: PlanExecution, service_id: 'forcast_unit_prices'},
  { path: '/bid-plan-profit', exact: true, name: '入札計画収益', component: BidPlanProfit },

  { path: '/changePassword', exact: true, name: 'パスワード変更', component: ChangePassword },
  {
    path: '/imbalance-prices',
    exact: true,
    name: 'インバランス予測単価',
    component: ImbalancePrices,
    service_id: 'imbalance_prices',
  },
  { path: '/site-information', exact: true, name: 'サイト情報', component: SiteInformation, service_id: 'site_info' },
  {
    path: '/transaction-results',
    exact: true,
    name: '取引実績取得',
    component: TransactionResults,
    service_id: 'transaction_results'
  },
  {
    path: '/sites-not-eligible-for-bidding',
    exact: true,
    name: 'サイト情報',
    component: SiteNotSubjectToBidding,
    service_id: 'not_available_periods'
  },
  {
    path: '/err',
    exact: true,
    name: 'Error',
    component: ErrorPage,
  },
];

export default routes;
